import React, { useEffect } from "react";
import { useHistory } from "react-router";
import GoodKarma from "../images/good-karma.png";
import Button from "../components/Button";
import SheWolf from "../images/corner/corner-shewolf.webp";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { MARKS, BLOCKS } from "@contentful/rich-text-types";

const MeetJulesScott = (props) => {
  const history = useHistory();
  const options = {
    renderMark: {
      [MARKS.BOLD]: (text) => <span className="fw-bold">{text}</span>,
    },
    renderNode: {
      [BLOCKS.EMBEDDED_ASSET]: (node) => (
        <img
          className="w-50 m-auto p-4"
          src={node.data?.target?.fields?.file?.url}
          alt={node.data?.target?.fields?.title}
        />
      ),
    },
  };
  useEffect(() => {
    document.title = "Auburn Road - Meet Jules and Scott";
    return () => {
      document.title = "Auburn Road Vineyards";
    };
  }, []);

  const wineStory = (item) => {
    const title =
      item.fields.uniqueUrl ||
      item.fields.title.split(" ").join("-").toLowerCase();
    const image = item.fields.storyImage
      ? item.fields.storyImage.fields.file.url
      : GoodKarma;
    const style = {
      "--bg-image": `url(${image})`,
    };
    return (
      <div className="wine-story-wrap">
        <div
          className="story-image pointer"
          style={style}
          bg-image={image}
          onClick={() => history.push("/" + title)}
        ></div>
        <h3
          className="m-b-20 pointer"
          onClick={() => history.push("/" + title)}
        >
          {item.fields.title}
        </h3>
        <div className="blurb">
          {documentToReactComponents(item.fields.blurb)}
          <Button
            onClick={() => history.push("/" + title)}
            className="continue-reading"
            small
            type="plain"
          >
            continue reading
          </Button>
        </div>
      </div>
    );
  };
  return (
    <>
      <img className="corner-shewolf" src={SheWolf} alt="" />
      <div className="container p-t-100 p-b-100">
        <h1>MEET</h1>
        <h1 className="huge-text-no-quote">
          <span className="accent-text">Jules</span> & Scott
        </h1>
        <div className="d-flex flex-md-row flex-column gap-5">
          <div className="d-flex flex-column m-t-50">
            {props.info.fields.images.map((x, i) => (
              <img
                key={x.sys?.id || i}
                className="width-300"
                src={x.fields.file.url}
                alt=""
              />
            ))}
          </div>
          <div className="inner-container  p-t-50">
            {documentToReactComponents(props.info.fields.body, options)}
          </div>
        </div>
        <div className="d-flex flex-column flex-md-row m-t-20">
          {props.info.fields.wineStories.map((x) => {
            return wineStory(x);
          })}
        </div>
      </div>
    </>
  );
};

export default MeetJulesScott;
